"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render(_c, _vm) {
  return _vm.props.user && _vm.$options.m.status(_vm.props) !== '' ? _c('span', {
    staticClass: "kiwi-typingstatusindicator kiwi-typing",
    class: {
      'kiwi-typingstatusindicator--paused': _vm.$options.m.status(_vm.props) === 'paused',
      [_vm.data.staticClass]: true
    }
  }) : _vm._e();
};
var staticRenderFns = exports.staticRenderFns = [];